import { render, staticRenderFns } from "./promoter.vue?vue&type=template&id=f2c1b408&scoped=true"
import script from "./promoter.vue?vue&type=script&lang=js"
export * from "./promoter.vue?vue&type=script&lang=js"
import style0 from "./promoter.vue?vue&type=style&index=0&id=f2c1b408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1b408",
  null
  
)

export default component.exports